import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface GeneralFilterBarDropdownsTriggersTriggerFilterBarFavouritesSignature {
  Args: {
    select: {
      disabled: boolean;
    };
  };
}

const GeneralFilterBarDropdownsTriggersTriggerFilterBarFavourites = <template>
  <button
    class="prism-button prism-button--secondary flex items-center gap-100 pr-100
      {{if @select.disabled 'disabled'}}"
    type="button"
  >
    <PrismIcon @name="star-filled" @size="small" />
    <PrismIcon @name="chevron-down" @size="small" />
  </button>
</template> satisfies TOC<GeneralFilterBarDropdownsTriggersTriggerFilterBarFavouritesSignature>;

export default GeneralFilterBarDropdownsTriggersTriggerFilterBarFavourites;
